<div class="qc-checklist">
    <div class="qc-checklist__header" *ngIf="showHeader && !readonly">
        <p-checkbox
            [ngModel]="allConfirmed"
            [binary]="true"
            (onChange)="toggleAll($event.checked)"
            inputId="qc-checklist-toggle-all"
            label="全部确认"
        ></p-checkbox>
    </div>

    <div class="qc-checklist__items">
        <div
            class="qc-checklist__item"
            *ngFor="let item of items; let i = index"
            [class.qc-checklist__item--confirmed]="item.isConfirmed"
            (click)="onItemClick(item)"
        >
            <div class="qc-checklist__item-checkbox">
                <p-checkbox
                    [ngModel]="item.isConfirmed"
                    [binary]="true"
                    [inputId]="'qc-item-' + i"
                    [disabled]="readonly"
                ></p-checkbox>
            </div>
            <div class="qc-checklist__item-content">
                <span
                    class="qc-checklist__item-title"
                    [class.qc-checklist__item-title--confirmed]="item.isConfirmed"
                >
                    <ng-container *ngIf="item.translateConfig; else plainTitle">
                        {{ item.title | translateValue : (item.translateConfig.titleTranslateGroups ?? undefined) }}
                    </ng-container>
                    <ng-template #plainTitle>{{ item.title }}</ng-template>
                </span>
                <div
                    class="qc-checklist__item-value"
                >
                    <ng-container *ngIf="item.isRichText; else plainTextValue">
                        <app-rich-text [text]="item.value" />
                    </ng-container>
                    <ng-template #plainTextValue>
                        <ng-container *ngIf="item.translateConfig; else plainValue">
                            {{ item.value | splitAndTranslate : (item.translateConfig.valueSeparator ?? ', ') : undefined : (item.translateConfig.valueTranslateGroups ?? undefined) }}
                        </ng-container>
                        <ng-template #plainValue>{{ item.value || '-' }}</ng-template>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>

    <div class="qc-checklist__summary" *ngIf="items.length > 0">
        <span class="qc-checklist__summary-text">
            已确认: {{ items.length - getUnconfirmedItems().length }} / {{ items.length }}
        </span>
    </div>
</div>
